import { EnvState } from "../env-state";
import { ServiceNameState } from "./service-name-state";
import { RedirectPath } from "./redirect-path";
import { RedirectUrl } from "./redirect-url";

const globalEnvState = new EnvState(process.env.NEXT_PUBLIC_ENVIRONMENT!);

const getRedirectURL = (
  envState: EnvState,
  serviceNameState: ServiceNameState,
  redirectPath: RedirectPath,
) => {
  return envState.matchLocal({
    // local環境はportを指定しないとリダイレクト先を特定できず、portは開発者によって異なるので、処理を止めてしまう。
    isLocal: () => RedirectUrl.createDefault(),
    notLocal: () =>
      RedirectUrl.create(envState, serviceNameState, redirectPath),
  });
};

export const ServiceRequest = (search: URLSearchParams) => {
  return ServiceRequestInner(
    globalEnvState,
    search.get("service"),
    search.get("redirectPath"),
    search.get("tenantSlug"),
  );
};

const ServiceRequestInner = (
  envState: EnvState,
  serviceParam: string | null,
  redirectPathParam: string | null,
  tenantSlug: string | null,
): {
  redirectUrl: RedirectUrl;
  displayServiceName: ServiceNameState;
  tenantSlug: string | null;
} => {
  const defaultResolve = {
    redirectUrl: RedirectUrl.createDefault(),
    displayServiceName: ServiceNameState.createDefault(),
    tenantSlug,
  };
  if (!serviceParam) {
    return defaultResolve;
  }
  const serviceNameState = ServiceNameState.create(serviceParam);
  if (!serviceNameState) {
    return defaultResolve;
  }
  const redirectPath = new RedirectPath(redirectPathParam || "/");
  const redirectUrl = getRedirectURL(envState, serviceNameState, redirectPath);
  return {
    redirectUrl: redirectUrl,
    displayServiceName: serviceNameState,
    tenantSlug,
  };
};
export const ServiceRequestInnerForTest = (
  envParam: string,
  serviceParam: string | null,
  redirectPathParam: string | null,
  tenantSlug: string | null,
) => {
  const envState = new EnvState(envParam);
  return ServiceRequestInner(
    envState,
    serviceParam,
    redirectPathParam,
    tenantSlug,
  );
};
